<div class="influencer-overview-container">
  <div class="row">
    <div class="col">
      <influencer-posts #InfluencerPosts 
                        (openIncompleteStory)="openIncompletedStoryWarning($event)" 
                        [postList]="influencerPostList" 
                        [influencerGroupId]="groupId" 
                        [imageReady]="readyToShowPost"
                        [isFetchingData]="isFetchingInfluencerPostList">
      </influencer-posts>
    </div>
  </div>

  <div class="row">
    <div class="col module-section">
      <brand-mentions [isFetchingData]="isFetchingInfluencerDetails" [brandMentions]="brandMentions"></brand-mentions>
    </div>
  </div>

  <div class="row inf-overview-row">
    <div class="col-12 col-xl-6 inf-overview-col module-section">
      <popular-topics [isFetchingData]="isFetchingInfluencerDetails" [popularTopic]="popularTopic"></popular-topics>
    </div>

    <div class="col-12 col-xl-6 inf-overview-col module-section">
      <sponsored-vs-organic [isFetchingData]="isFetchingInfluencerDetails" [sponsoredOrganicPercentage]="sponsoredOrganicPercentage">
      </sponsored-vs-organic>
    </div>
  </div>

  <div class="row">
    <div class="col module-section">
      <related-influencers [isFetchingData]="isFetchingInfluencerDetails" [relatedInfluencers]="relatedInfluencers"></related-influencers>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <latest-posts [isFetchingData]="isFetchingLatestPosts" [latestPosts]="latestPosts" [forPayingUser]="true"></latest-posts>
    </div>
  </div>
</div>

<achoo-popup #NotificationFetchingStoryError
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}"
             (closeCallback)="closeNotification()">
  <span [innerHTML]="storyErrorMessage | translate"></span>
</achoo-popup>
<achoo-popup #NotificationGetNewStorySuccess
             [isNotification]="true"
             (closeCallback)="closeNotification()"
             modelTitle="{{'notification.success' | translate}}">
  <span>{{storySuccessMessage}}</span>
</achoo-popup>
<achoo-popup #NotificationWarningOpenIncompletedStory
             [isAlertPopup]="true"
             modelTitle="{{'story.error.incompleted_title' | translate}}"
             [acceptBtnLabel]="'story.error.incompleted_btn' | translate"
             (closeCallback)="closeNotification()"
             (acceptCallback)="closeNotification()"
             (cancelCallback)="closeNotification()">
  <span>{{storyIncompleteMessage}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/influencer-overview.component.html